import { render, staticRenderFns } from "./ProductAll.vue?vue&type=template&id=265a4340&scoped=true"
import script from "./ProductAll.vue?vue&type=script&lang=js"
export * from "./ProductAll.vue?vue&type=script&lang=js"
import style0 from "./ProductAll.vue?vue&type=style&index=0&id=265a4340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a4340",
  null
  
)

export default component.exports